import { wildcard } from "../../wildcard/VibescoutSpecial_WildcardClient";
import { createAsyncActionDirect } from "pullstate";

const updateSession = createAsyncActionDirect(wildcard.setSessionValue);

export const CommonAsyncActions = {
  updateSession
};
